<template lang="pug">
.pending-approval-list
  GenericCard.productList(size='85' :ignoreMaxWidth='true')
    .sticky-top.bg-white
      .d-flex.align-items-end.px-4.py-4
        //- CustomCategoriesFilter(
        //-   title='เลือกดูตามเขต'
        //-   :items='statusList'
        //-   v-model='filterArea'
        //- )
        CustomAreaFilter(
          title='เลือกดูตามเขต'
          v-model='filterArea'
        )
        PanelTitleRight.ml-auto(
          title='รายการรออนุมัติ'
          :subtitle='tableData ? `${totalRows} รายการ`:`...`'
          v-model='filterDate'
        )
      .w-100.px-4.py-2
        CustomSearchBox.ml-auto(
          v-model='filterSearch'
          :isLoading='isLoading'
          type='text' placeholder='ค้นหาด้วยเลขที่รายการ'
          width='100%'
        )

      hr.mb-0

    LoadedContentWrapper.flex-fill(
      :isLoading='isLoading'
      :data='tableData'
      @reload='loadData'
    )
      .py-2.px-3.scrollable.h-scrollable
        CustomTable.w-max-content(
          :columns='tableColumns'
          :data='filteredTableData'
          :showIndexes='true'
          :showNotificationDots='true'
          :startIndex='pageFirstRowIndex'
          @itemClicked='itemClicked'
        )

      .sticky-bottom.bg-white
        hr.m-0
        .px-4.py-3
          CustomPagination(
            v-model='currentPage'
            :total='totalPage'
          )
  //- modal(
  //-   name='admin-approval'
  //-   width='90%' height='95%'
  //-   transition='modal-transition'
  //- )
  //-   CSSellRecordDetail(
  //-     :sellRecord='selectedItem'
  //-     :customer='selectedItem'
  //-     @closeButtonClicked='hideModal'
  //-   )

</template>

<script>
/* eslint-disable arrow-body-style */
import CSSellRecordDetail from '@/components/_cs/sell-records/dialogs/SellRecord/CSSellRecordDetail.vue';

export default {
  props: {
    shouldRefresh: { default: false },
  },
  watch: {
    // customer(newVal) {
    //   this.loadData(newVal);
    // },
    async shouldRefresh() {
      if (this.shouldRefresh === true) {
        await this.loadData();
        this.shouldRefresh = false;
      }
    },

    // reload data
    filterDate: {
      deep: true,
      handler() { this.currentPage = 1; this.loadData(); },
    },
    filterSearch() { this.currentPage = 1; this.loadData(); },
    filterArea() { this.currentPage = 1; this.loadData(); },
    currentPage() { this.loadData(); },
  },
  computed: {
    filteredTableData() {
      // const KEYWORD = this.filterSearch.toUpperCase();
      // return this.tableData.filter((item) => {
      //   return (
      //     // (this.filterDate === '' || this.$dateUtils.isInRange(item.date, this.filterDate))
      //     (!this.filterArea
      //       || (item.customer.zone && item.customer.zone.toString() === this.filterArea)
      //     )
      //     && (!KEYWORD
      //       || (item.customer && item.customer.name
      //         && item.customer.name.toUpperCase().includes(KEYWORD))
      //       || (item.user && item.user.name
      //         && item.user.name.toUpperCase().includes(KEYWORD))
      //     )
      //   );
      // });
      return this.tableData;
    },
  },
  data() {
    return {
      isLoading: false,

      // statusList: {
      //   NE: 'NE',
      //   NW: 'NW',
      //   SE: 'SE',
      //   N: 'N',
      //   C: 'C',
      // },
      filterArea: '',

      filterDate: '',
      filterSearch: '',
      tableData: [],
      tableColumns: {
        date: {
          title: 'วันที่ทำรายการ',
          align: 'left',
          type: Date,
        },
        entryNo: {
          title: 'เลขที่',
          align: 'left',
          type: 'EntryNo',
        },
        customerZone: {
          title: 'เขต',
          align: 'center',
          computed: (row) => {
            if (row.customer) {
              return row.customer.zone;
            }
            return '-';
          },
        },
        customerName: {
          title: 'ชื่อลูกค้า',
          align: 'left',
          computed: (row) => {
            if (row.customer) {
              return row.customer.name;
            }
            return '-';
          },
        },
        weight: {
          title: 'น.น.',
          align: 'right',
          type: Number,
          computed: (row) => {
            if (row.products) {
              const totalWeight = row.products.reduce((prev, elm) => {
                return prev + Number(elm.product ? elm.product.weight : 0);
              }, 0);
              return totalWeight;
            }
            return '-';
          },
        },
        total: {
          title: 'ยอดรวม',
          align: 'right',
          type: Number,
          // computed(row) {
          //   if (row.products) {
          //     return row.products.reduce((total, prod) => (total + Number(prod.price)), 0);
          //   }
          //   return 0;
          // },
        },
        sellerName: {
          title: 'ผู้ขาย',
          align: 'right',
          computed: (row) => {
            if (row.user) {
              return row.user.name;
            }
            return '-';
          },
        },
        status: {
          title: 'สถานะ',
          align: 'center',
          type: this.$api.cs.customer.COL_TYPE.OrderStatus,
        },
        shipmentStatus: {
          title: 'สถานะจัดส่ง',
          align: 'center',
          type: this.$api.cs.customer.COL_TYPE.ShipmentStatus,
        },
      },

      currentPage: 1,
      totalPage: 0,
      totalRows: 0,
      pageFirstRowIndex: 1,

      selectedItem: {},
    };
  },
  methods: {
    async loadData() {
      this.isLoading = true;

      // reset data
      this.tableData = null;

      // load data
      try {
        // const res = await this.$api.admin.pendingApproval.list();
        const res = await this.$api.cs.sellRecord.adminApprovalList(
          this.currentPage,
          this.filterDate.from,
          this.filterDate.to,
          this.filterSearch,
          this.filterArea,
        );
        if (res.status === 200) {
          this.tableData = res.data.data;
          this.currentPage = res.data.current_page;
          this.totalPage = res.data.last_page;
          this.totalRows = res.data.total;
          this.pageFirstRowIndex = res.data.from;
        }
      } catch (e) {
        this.tableData = null;
        this.pageFirstRowIndex = 1;
      }

      this.$emit('finishLoading');

      this.isLoading = false;
    },
    // showModal(e) {
    //   this.selectedItem = e.data;
    //   this.$modal.show('admin-approval');
    // },
    // hideModal() {
    //   // console.log('close');
    //   this.$modal.hide('admin-approval');
    // },
    itemClicked(e) {
      this.$emit('itemClicked', e.data);
    },
  },
  mounted() {
    // const id = this.customer ? this.customer.id : '';
    this.loadData();
  },
  components: {
    CSSellRecordDetail,
  },
};
</script>

<style lang="scss">
// .pending-approval-list {}
</style>
